import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import moment from "moment/moment";
import MyMixin from "@/mixins/datemixin";

@Component
export default class CoffreMixin extends mixins(MyMixin) {
  public recus: any;
  public criteres = { start: "", end: "", site: -1, action: "" };
  public vendeur: string = "";
  public caisse: string = "";
  public localisation = "";
  public total = "";
  public ticket = "";
  public tickets: any = [];

  public getComptageCaisseHeaders() {
    return [
      {
        text: this.$t("date"),
        value: "validationHorodatage",
        class: "data-head",
        width: "18%",
      },
      /*{text: "Recu", sortable: false,  value: "recuNum", class: "data-head", width: "7%", },*/
      {
        text: this.$t("Vendeur"),
        value: "libVendeur",
        class: "data-head",
        width: "12%",
      },
      {
        text: this.$t("Manager"),
        value: "validationResponsable",
        class: "data-head",
        width: "12%",
      },
      {
        text: this.$t("libCaisse"),
        value: "libCaisse",
        class: "data-head",
        width: "12%",
      },
      {
        text: this.$t("Theo"),
        value: "theo",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("Réel"),
        value: "reel",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("Ecart"),
        value: "diff",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("En Attente"),
        value: "wait",
        class: "data-head text-no-wrap",
        width: "10%",
      },
    ];
  }

  public getMouvementsHeaders() {
    return [
      {
        text: this.$t("date"),
        value: "validationHorodatage",
        class: "data-head",
        width: "18%",
      },
      {
        text: this.$t("Manager"),
        value: "validationResponsable",
        class: "data-head max10",
        width: "12%",
      },
      {
        text: this.$t("HT"),
        value: "montant0",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("TVA"),
        value: "montant1",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("TTC"),
        value: "montant2",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("Description"),
        value: "ruleDescription",
        class: "data-head",
        width: "12%",
      },
    ];
  }

  public getVidagesHeaders() {
    const heads = [
      {
        text: this.$t("date"),
        value: "validationHorodatage",
        class: "data-head text-no-wrap",
        width: "18%",
      },
      {
        text: this.$t("Manager"),
        value: "validationResponsable",
        class: "data-head",
        width: "10%",
      },
      {
        text: this.$t("Theo"),
        value: "montant1",
        class: "data-head text-no-wrap",
        width: "10%",
      },
      {
        text: this.$t("Vidage"),
        value: "montant0",
        class: "data-head text-no-wrap",
        width: "8%",
      },
      {
        text: this.$t("Anomalie"),
        value: "montant2",
        class: "data-head text-no-wrap",
        width: "8%",
      },
      {
        text: this.$t("Description"),
        value: "ruleDescription",
        class: "data-head",
        width: "12%",
      },
    ];
    if (this.client === "BUFFALO") {
      heads.push({
        text: this.$t("Decade"),
        value: "pdf",
        class: "data-head",
        width: "4%",
      });
    }
    return heads;
  }

  public getHeaderTicketBk(): any {
    return [
      {
        text: this.$t("date"),
        value: "horodatage",
        class: "data-head",
      },
      {
        text: this.$t("libCaisse"),
        value: "libcaisse",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.caisse.toLowerCase()),
      },
      {
        text: this.$t("Vendeur"),
        value: "libvendeur",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.vendeur.toLowerCase()),
      },
      {
        text: this.$t("ticket"),
        value: "numticket",
        class: "data-head",
        sortable: false,
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.ticket.toLowerCase()),
      },
      {
        text: this.$t("total"),
        value: "total",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.total.toLowerCase()),
      },
      {
        text: this.$t("localisation"),
        value: "localisation",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.localisation.toLowerCase()),
      },
    ];
  }
  public getRecuHeaders(): any {
    return [
      {
        value: "horodatage",
        text: this.$t("Date.etheure"),
        class: "data-head",
      },
      {
        value: "libvendeur",
        text: this.$t("vendeur"),
        class: "data-head",
      },
      {
        value: "libcaisse",
        text: this.$t("libCaisse"),
        class: "data-head",
      },
      {
        value: "libbeneficiaire",
        text: this.$t("beneficiaire"),
        class: "data-head",
      },
      {
        value: "couronnes",
        text: this.$t("couronnes"),
        class: "data-head",
      },
      {
        value: "recunum",
        text: this.$t("recunum"),
        class: "data-head",
      },
    ];
  }

  public getTotalTicketHeaders(): any {
    return [
      {
        text: this.$t("Site"),
        align: "start",
        sortable: true,
        value: "site",
        class: "data-head",
      },
      { text: this.$t("date"), value: "horodatage", class: "data-head" },
      { text: this.$t("libCaisse"), value: "libcaisse", class: "data-head" },
      { text: this.$t("Vendeur"), value: "libvendeur", class: "data-head" },
      { text: this.$t("ticket"), value: "numticket", class: "data-head" },
      { text: this.$t("Total"), value: "total", class: "data-head" },
    ];
  }

  public getAnnulationsHeaders() {
    return [
      {
        text: this.$t("Vendeur").toString(),
        value: "libelle",
        class: "data-head",
      },
      { text: this.$t("CA").toString(), value: "ca", class: "data-head" },
      {
        text: this.$t("Nbr").toString(),
        value: "nombreAnnulation",
        class: "data-head",
      },
      {
        text:
          this.$t("Montant").toString() +
          " " +
          this.$t("annulations").toString(),
        value: "montantAnnulation",
        class: "data-head",
      },
      {
        text: this.$t("Repartitions").toString(),
        value: "repart",
        class: "data-head",
      },
      {
        text:
          this.$t("Taux").toString() + " " + this.$t("annulation").toString(),
        value: "taux",
        class: "data-head text-no-wrap",
      },
    ];
  }

  public getCorrectionsHeaders() {
    return [
      {
        text: this.$t("Vendeur").toString(),
        value: "libelle",
        class: "data-head",
      },
      { text: this.$t("CA").toString(), value: "ca", class: "data-head" },
      {
        text: this.$t("Nbr").toString(),
        value: "nombreCorrection",
        class: "data-head",
      },
      {
        text:
          this.$t("Montant").toString() +
          " " +
          this.$t("corrections").toString(),
        value: "montantAnnulation",
        class: "data-head",
      },
      {
        text: this.$t("Repartitions").toString(),
        value: "repart",
        class: "data-head",
      },
      {
        text:
          this.$t("Taux").toString() + " " + this.$t("correction").toString(),
        value: "taux",
        class: "data-head text-no-wrap",
      },
    ];
  }

  public getCsvTitle() {
    return `${this.criteres.site}-${this.criteres.action}-${this.criteres.start}-${this.criteres.end}`;
  }

  public getCsvRecus() {
    let recusJson = new Array();
    recusJson = this.recus.map((recu: any) => {
      return this.transformRecu(recu);
    });
    return recusJson;
  }

  public getCsvTickets() {
    let recusJson = new Array();
    recusJson = this.tickets.map((recu: any) => {
      return this.transformTicket(recu);
    });
    return recusJson;
  }

  private transformRecu(recu: any) {
    let obj;
    if (this.criteres.action.includes("Declare")) {
      obj = {
        recuNum: recu.recuNum,
        dateFiscale: this.formatDateTicket(recu.dateFiscale),
        caisse: recu.recuGenerator,
        // heureOuvertude: this.formatDateTicketHour(recu.age),
        heureFermeture: this.formatDateTicketHour(recu.horodatage),
        codeResponsablesession: recu.managerCode,
        responsableSession: recu.managerName,
        numVendeur: recu.numVendeur,
        nomVendeur: recu.libVendeur,
        heureValidation: this.formatDateTicketHour(recu.validationHorodatage),
        responsableValidation: recu.validationResponsable,
        montantTheorique: this.formatNumber(recu.theo),
        montantReel: this.formatNumber(recu.reel),
        montantEcart: this.formatNumber(recu.diff),
        session: recu.id,
      };
    } else if (this.criteres.action.includes("mouvements")) {
      obj = {
        recuNum: recu.recuNum,
        date: this.formatDateTicketHour(recu.horodatage),
        description: recu.ruleDescription,
        responsable: recu.managerName,
        numResponsable: recu.managerCode,
        HT: this.formatNumber(recu.montant0),
        TVA: this.formatNumber(recu.montant1),
        TTC: this.formatNumber(recu.montant2),
        session: recu.id,
      };
    } else if (this.criteres.action.includes("vidages")) {
      obj = {
        recuNum: recu.recuNum,
        date: this.formatDateTicketHour(recu.horodatage),
        description: recu.ruleDescription,
        responsable: recu.managerName,
        numResponsable: recu.managerCode,
        montantTheorique: this.formatNumber(recu.montant1),
        montantVidage: this.formatNumber(recu.montant0),
        anomalie: this.formatNumber(recu.montant2),
        session: recu.id,
      };
    } else {
      obj = recu;
    }

    return obj;
  }

  private transformTicket(recu: any) {
    const obj = {
      date: this.formatDateTicket(recu.horodatage),
      caisse: recu.libcaisse,
      numTicket: recu.numticket,
      numVendeur: recu.numvendeur,
      nomVendeur: recu.libvendeur,
      localisation: recu.localisation,
      total: this.formatNumber(recu.total),
      id: recu.id,
    };
    return obj;
  }

  private formatNumber(num: number) {
    const n = num.toFixed(2);
    return n;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
